/** @format */
import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'sis-required-field-legend',
    templateUrl: './required-field-legend.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class RequiredFieldLegendComponent {}
